/* mt-wishlist.js — 2026-09-24 (round 3: slide-out panel, in-place remove, bought-it cleanup)
 * Wishlist behaviour for moderntribe.com on top of Gift Reggie's storefront API.
 *
 *   GET  /apps/giftregistry/api/wishlist          -> { wishlist: { id, created, products:[{variant_id,title,handle,image,price,…}] } | null }
 *   POST /apps/giftregistry/api/wishlist/add      { id: variantId }
 *   POST /apps/giftregistry/api/wishlist/open     (first save creates the list; the app
 *                                                 answers 400 {error:null} to /add until then)
 *   POST /apps/giftregistry/api/wishlist/remove   { id: variantId }
 *
 * Identity comes from the Shopify app proxy, so the API only works for signed-in
 * customers. Guests get an explanation, sign in with the store's one-time code,
 * and the save they asked for is finished for them when they land back here.
 *
 * Pieces: config (snippets/mt-wishlist-config.liquid), product-page control
 * (snippets/mt-wishlist-button.liquid), header heart (snippets/mt-wishlist-header.liquid),
 * the slide-out panel (built here on first open; Theme settings › Wishlist toggle),
 * and Gift Reggie's own wishlist page, enhanced in place.
 */
(function () {
  'use strict';
  var cfgEl = document.getElementById('mt-wl-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var L = cfg.labels || {};
  var CUSTOMER = cfg.customerId || null;
  var STORE_KEY = 'mt_wl_state2';
  var PENDING_KEY = 'mt_wl_pending';
  var KEEP_KEY = 'mt_wl_keep';          // variants the shopper put back after a bought-it cleanup
  var STORE_TTL = 5 * 60 * 1000;      // re-check the server after 5 minutes
  var PENDING_TTL = 40 * 60 * 1000;   // a sign-in started 40+ minutes ago is stale
  var HEART = '<svg class="mt-wl-heart" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M12 20.6l-1.3-1.2C5.9 15.1 2.8 12.3 2.8 8.8 2.8 6 5 3.9 7.7 3.9c1.6 0 3.2.8 4.3 2.1 1.1-1.3 2.7-2.1 4.3-2.1 2.7 0 4.9 2.1 4.9 4.9 0 3.5-3.1 6.3-7.9 10.6L12 20.6z"/></svg>';

  /* ---------- helpers ---------- */
  function read(storage, key) { try { return JSON.parse(storage.getItem(key)); } catch (e) { return null; } }
  function write(storage, key, value) { try { if (value == null) storage.removeItem(key); else storage.setItem(key, JSON.stringify(value)); } catch (e) { /* private mode etc. */ } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(p) { var n = parseFloat(p); if (isNaN(n)) return ''; return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)); }
  function thumb(url, w) { if (!url) return ''; return url.replace(/(\.[a-z]{3,4})(\?|$)/i, '_' + w + 'x' + w + '$1$2'); }
  function emit(name, detail) { try { document.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); } catch (e) { /* old browsers */ } }
  function pageUrl() { return cfg.wishlistUrl + (store.listId() ? '/' + store.listId() : ''); }
  function loginUrlFor(returnPath) {
    var base = cfg.loginUrl || '/account/login';
    return base + (base.indexOf('?') === -1 ? '?' : '&') + 'return_to=' + encodeURIComponent(returnPath);
  }

  /* ---------- API ---------- */
  function api(path, body) {
    var opts = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body !== undefined) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json; charset=UTF-8';
      opts.body = JSON.stringify(body);
    }
    return fetch(cfg.apiBase + path, opts).then(function (r) {
      if (r.ok) return r.status === 204 ? null : r.json().catch(function () { return null; });
      return r.text().then(function (t) {
        var err = new Error('wishlist api ' + r.status);
        err.status = r.status;
        try { err.payload = JSON.parse(t); } catch (e) { err.payload = null; }
        throw err;
      });
    });
  }
  function apiAdd(id, retried) {
    return api('/wishlist/add', { id: id }).catch(function (err) {
      var noList = err.status === 400 && err.payload && err.payload.error === null;
      if (noList && !retried) return api('/wishlist/open', null).then(function () { return apiAdd(id, true); });
      throw err;
    });
  }
  function apiRemove(id) { return api('/wishlist/remove', { id: id }); }
  function cartAdd(variantId) {
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  // Rebuy sees the native /cart/add.js call and opens the Smart Cart itself; nudge it if it did not
  function nudgeSmartCart() {
    setTimeout(function () {
      try {
        var d = document.querySelector('.rebuy-cart');
        if (window.Rebuy && Rebuy.SmartCart && Rebuy.SmartCart.show && d && !d.classList.contains('is-visible')) {
          if (Rebuy.Cart && Rebuy.Cart.fetchCart) Rebuy.Cart.fetchCart();
          Rebuy.SmartCart.show();
        }
      } catch (err) { /* ignore */ }
    }, 900);
  }

  /* ---------- state: the saved products ---------- */
  var store = (function () {
    var state = read(sessionStorage, STORE_KEY);
    if (!state || state.customer !== CUSTOMER) state = null;
    var loading = null;
    function slim(p) { return { variant_id: String(p.variant_id), product_id: p.product_id, title: p.title, handle: p.handle, image: p.image, price: p.price }; }
    function blank() { return { products: [], at: 0, listId: null, created: null }; }
    function changed() { state.customer = CUSTOMER; write(sessionStorage, STORE_KEY, state); emit('mt:wishlist:change', { ids: state.products.map(function (p) { return p.variant_id; }) }); }
    return {
      ready: function (force) {
        if (!CUSTOMER) { state = blank(); state.at = Date.now(); return Promise.resolve(state); }
        if (!force && state && Date.now() - state.at < STORE_TTL) return Promise.resolve(state);
        if (loading) return loading;
        loading = api('/wishlist').then(function (data) {
          var w = data && data.wishlist;
          state = { products: (w && w.products || []).map(slim), at: Date.now(), listId: w ? w.id : null, created: w ? w.created : null };
          changed();
          return state;
        }).catch(function () {
          if (!state) state = blank();
          return state;
        }).finally(function () { loading = null; });
        return loading;
      },
      loaded: function () { return !!state && state.at > 0; },
      products: function () { return state ? state.products : []; },
      ids: function () { return this.products().map(function (p) { return p.variant_id; }); },
      listId: function () { return state ? state.listId : null; },
      created: function () { return state ? state.created : null; },
      has: function (id) { return this.ids().indexOf(String(id)) !== -1; },
      add: function (id, meta) { if (!state) state = blank(); if (!this.has(id)) state.products.push({ variant_id: String(id), title: meta && meta.title, handle: meta && meta.handle, image: meta && meta.image, price: meta && meta.price }); state.at = state.at || 1; changed(); },
      remove: function (id) { if (!state) return; state.products = state.products.filter(function (p) { return p.variant_id !== String(id); }); changed(); },
      // the wishlist page is server-rendered truth for ids; keep any product details we already had
      setIds: function (ids) { if (!state) state = blank(); var known = {}; state.products.forEach(function (p) { known[p.variant_id] = p; }); state.products = ids.map(function (id) { return known[String(id)] || { variant_id: String(id) }; }); changed(); }
    };
  })();

  /* ---------- pending save (guest -> sign in -> back) ---------- */
  function setPending(p) { write(localStorage, PENDING_KEY, p); }
  function getPending() {
    var p = read(localStorage, PENDING_KEY);
    if (!p || !p.variant) return null;
    if (Date.now() - (p.at || 0) > PENDING_TTL) { setPending(null); return null; }
    return p;
  }

  /* ---------- already bought: take purchased items off the list, with undo ---------- */
  var bought = (function () {
    function purchasedSince(createdIso) {
      var since = 0;
      if (createdIso) { var t = Date.parse(/[zZ]|[+-]\d\d:?\d\d$/.test(createdIso) ? createdIso : createdIso.replace(' ', 'T') + 'Z'); if (!isNaN(t)) since = t / 1000; }
      var set = {};
      (cfg.orders || []).forEach(function (o) {
        if (o.c || !(o.t > since)) return;
        (o.v || []).forEach(function (v) { if (v) set[String(v)] = true; });
      });
      return set;
    }
    function keep() { return read(localStorage, KEEP_KEY) || []; }
    return {
      // resolves with the products that were removed (possibly none)
      run: function () {
        if (!CUSTOMER || !store.loaded()) return Promise.resolve([]);
        var purchased = purchasedSince(store.created());
        var kept = keep();
        var hits = store.products().filter(function (p) { return purchased[p.variant_id] && kept.indexOf(p.variant_id) === -1; });
        if (!hits.length) return Promise.resolve([]);
        return hits.reduce(function (chain, p) {
          return chain.then(function (done) { return apiRemove(p.variant_id).then(function () { store.remove(p.variant_id); done.push(p); return done; }).catch(function () { return done; }); });
        }, Promise.resolve([]));
      },
      undo: function (products) {
        var list = keep();
        products.forEach(function (p) { if (list.indexOf(p.variant_id) === -1) list.push(p.variant_id); });
        write(localStorage, KEEP_KEY, list);
        return Promise.all(products.map(function (p) { return apiAdd(p.variant_id).then(function () { store.add(p.variant_id, p); }); }));
      },
      noticeText: function (products) {
        if (products.length === 1) return (L.purchasedOne || 'We took [title] off your list since you ordered it.').replace(/\[title\]|\{title\}/g, products[0].title || 'an item');
        return (L.purchasedMany || 'We took [count] items off your list since you ordered them.').replace(/\[count\]|\{count\}/g, products.length);
      }
    };
  })();
  function boughtNotice(products, onUndone) {
    var el = document.createElement('div');
    el.className = 'mt-wl-notice';
    el.setAttribute('role', 'status');
    el.innerHTML = '<span class="mt-wl-notice__text">' + esc(bought.noticeText(products)) + '</span> <button type="button" class="mt-wl-notice__undo">' + esc(L.undo || 'Undo') + '</button>';
    var btn = el.querySelector('button');
    btn.addEventListener('click', function () {
      btn.disabled = true;
      bought.undo(products).then(function () {
        el.querySelector('.mt-wl-notice__text').textContent = L.undone || 'Back on your list.';
        btn.remove();
        el.setAttribute('tabindex', '-1'); el.focus();
        if (onUndone) onUndone(products);
        setTimeout(function () { el.remove(); }, 2500);
      }).catch(function () { btn.disabled = false; });
    });
    return el;
  }

  /* ---------- toast ---------- */
  function toast(html) {
    var old = document.querySelector('.mt-wl-toast');
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'mt-wl-toast';
    el.setAttribute('role', 'status');
    el.innerHTML = HEART + '<span>' + html + '</span><button type="button" aria-label="' + esc(L.close || 'Dismiss') + '">×</button>';
    el.querySelector('button').addEventListener('click', function () { el.remove(); });
    document.body.appendChild(el);
    setTimeout(function () { if (el.parentNode) el.remove(); }, 7000);
  }

  /* ---------- slide-out panel ---------- */
  var drawer = (function () {
    var root = null, panel = null, body = null, countEl = null, foot = null, lastFocus = null, isOpen = false;
    function enabled() { return !!cfg.drawerEnabled; }
    function build() {
      if (root) return;
      root = document.createElement('div');
      root.className = 'mt-wl-drawer';
      root.hidden = true;
      root.innerHTML =
        '<div class="mt-wl-drawer__overlay" data-mt-wl-close></div>' +
        '<div class="mt-wl-drawer__panel" role="dialog" aria-modal="true" aria-labelledby="mt-wl-drawer-title" tabindex="-1">' +
          '<div class="mt-wl-drawer__head">' +
            '<h2 class="mt-wl-drawer__title" id="mt-wl-drawer-title">' + esc(L.drawerTitle || 'Your wishlist') + ' <span class="mt-wl-drawer__count" data-mt-wl-drawer-count hidden></span></h2>' +
            '<button type="button" class="mt-wl-drawer__close" data-mt-wl-close aria-label="' + esc(L.close || 'Close') + '">×</button>' +
          '</div>' +
          '<div class="mt-wl-drawer__body" data-mt-wl-drawer-body></div>' +
          '<div class="mt-wl-drawer__foot" data-mt-wl-drawer-foot hidden>' +
            '<button type="button" class="mt-wl-drawer__share" data-mt-wl-share>' + esc(L.copyShare || 'Copy share link') + '</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(root);
      panel = root.querySelector('.mt-wl-drawer__panel');
      body = root.querySelector('[data-mt-wl-drawer-body]');
      countEl = root.querySelector('[data-mt-wl-drawer-count]');
      foot = root.querySelector('[data-mt-wl-drawer-foot]');
      root.querySelectorAll('[data-mt-wl-close]').forEach(function (el) { el.addEventListener('click', close); });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); return; }
        if (e.key !== 'Tab') return;
        var f = panel.querySelectorAll('button:not([disabled]), a[href], input, [tabindex="0"]');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      var share = root.querySelector('[data-mt-wl-share]');
      share.addEventListener('click', function () {
        var url = location.origin + pageUrl();
        var done = function () { share.textContent = L.copied || 'Copied'; share.classList.add('is-copied'); setTimeout(function () { share.textContent = L.copyShare || 'Copy share link'; share.classList.remove('is-copied'); }, 2000); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, done); else done();
      });
      document.addEventListener('mt:wishlist:change', function () { if (isOpen) render(); });
      // Escape should work even when focus has drifted out of the panel
      document.addEventListener('keydown', function (e) { if (isOpen && e.key === 'Escape') close(); });
    }
    function open(trigger) {
      build();
      lastFocus = trigger && trigger.focus ? trigger : document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add('mt-wl-drawer-open');
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      isOpen = true;
      render();
      panel.focus();
      if (CUSTOMER) {
        store.ready().then(function () {
          render();
          return bought.run();
        }).then(function (removed) {
          if (removed.length) { render(); body.insertBefore(boughtNotice(removed, render), body.firstChild); }
        });
      }
    }
    function close() {
      if (!root || !isOpen) return;
      isOpen = false;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('mt-wl-drawer-open');
      setTimeout(function () { if (!isOpen) root.hidden = true; }, 260);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function render() {
      if (!root) return;
      var notice = body.querySelector('.mt-wl-notice');
      if (!CUSTOMER) {
        countEl.hidden = true; foot.hidden = true;
        body.innerHTML = '<div class="mt-wl-card mt-wl-card--flat">' + HEART + '<h3>' + esc(L.signedOutTitle || 'Your wishlist') + '</h3><p>' + esc(L.signedOutText || '') + '</p>' +
          '<a class="mt-wl-card-btn" href="' + loginUrlFor(location.pathname) + '">' + esc(L.signIn || 'Sign in') + '</a></div>';
        return;
      }
      if (!store.loaded()) {
        body.innerHTML = '<p class="mt-wl-drawer__loading">' + esc(L.loading || 'Loading') + '…</p>';
        foot.hidden = true;
        return;
      }
      var items = store.products();
      countEl.textContent = items.length; countEl.hidden = items.length === 0;
      foot.hidden = !store.listId();
      if (!items.length) {
        body.innerHTML = '<div class="mt-wl-card mt-wl-card--flat">' + HEART + '<h3>' + esc(L.emptyTitle || 'Nothing saved yet.') + '</h3><p>' + esc(L.emptyText || '') + '</p>' +
          '<a class="mt-wl-card-btn" href="' + esc(cfg.browseUrl || '/collections/new') + '">' + esc(cfg.browseLabel || 'Browse') + '</a></div>';
      } else {
        body.innerHTML = '<ul class="mt-wl-drawer__list">' + items.map(function (p) {
          var href = p.handle ? '/products/' + p.handle + '?variant=' + p.variant_id : '#';
          return '<li class="mt-wl-drawer__item" data-variant="' + esc(p.variant_id) + '">' +
            '<a class="mt-wl-drawer__thumb" href="' + esc(href) + '" tabindex="-1" aria-hidden="true">' + (p.image ? '<img src="' + esc(thumb(p.image, 160)) + '" alt="" loading="lazy" width="72" height="72">' : '') + '</a>' +
            '<div class="mt-wl-drawer__info">' +
              '<a class="mt-wl-drawer__name" href="' + esc(href) + '">' + esc(p.title || 'Saved item') + '</a>' +
              (p.price ? '<span class="mt-wl-drawer__price">' + esc(money(p.price)) + '</span>' : '') +
              '<div class="mt-wl-drawer__actions">' +
                '<button type="button" class="mt-wl-drawer__add" data-mt-wl-add>' + esc(L.addToCart || 'Add to cart') + '</button>' +
                '<button type="button" class="mt-wl-drawer__remove" data-mt-wl-remove>' + esc(L.remove || 'Remove') + '</button>' +
              '</div>' +
              '<p class="mt-wl-drawer__msg" role="status"></p>' +
            '</div>' +
          '</li>';
        }).join('') + '</ul>';
        body.querySelectorAll('.mt-wl-drawer__item').forEach(function (li) {
          var id = li.getAttribute('data-variant');
          var add = li.querySelector('[data-mt-wl-add]');
          var rem = li.querySelector('[data-mt-wl-remove]');
          var msg = li.querySelector('.mt-wl-drawer__msg');
          add.addEventListener('click', function () {
            if (add.disabled) return;
            add.disabled = true; add.textContent = (L.adding || 'Adding') + '…'; msg.textContent = '';
            cartAdd(id).then(function () {
              add.textContent = L.added || 'Added';
              emit('mt:cart:added', { id: id });
              setTimeout(function () { close(); nudgeSmartCart(); add.disabled = false; add.textContent = L.addToCart || 'Add to cart'; }, 350);
            }).catch(function (err) {
              add.disabled = false; add.textContent = L.addToCart || 'Add to cart';
              msg.textContent = (err && (err.description || err.message)) || 'That did not add. Try again.';
            });
          });
          rem.addEventListener('click', function () {
            if (rem.disabled) return;
            rem.disabled = true; rem.textContent = (L.removing || 'Removing') + '…';
            li.classList.add('is-removing');
            apiRemove(id).then(function () { setTimeout(function () { store.remove(id); }, 220); }).catch(function () {
              li.classList.remove('is-removing'); rem.disabled = false; rem.textContent = L.remove || 'Remove';
              msg.textContent = L.error || 'That did not work. Try again.';
            });
          });
        });
      }
      if (notice) body.insertBefore(notice, body.firstChild);
    }
    function bindTriggers() {
      if (!enabled()) return;
      document.addEventListener('click', function (e) {
        var a = e.target.closest('[data-mt-wl-view], [data-mt-wl-header], a[data-mt-wl-open]');
        if (!a) return;
        if (document.querySelector('.giftreggie-front.giftreggie-wishlist')) return; // already on the page
        e.preventDefault();
        var t = e.target.closest('.mt-wl-toast');
        if (t) t.remove();
        open(a);
      });
    }
    return { enabled: enabled, open: open, close: close, bindTriggers: bindTriggers };
  })();

  /* ---------- product page control ---------- */
  function initControl(root) {
    var btn = root.querySelector('[data-mt-wl-btn]');
    var label = root.querySelector('[data-mt-wl-label]');
    var view = root.querySelector('[data-mt-wl-view]');
    var sep = root.querySelector('[data-mt-wl-sep]');
    var status = root.querySelector('[data-mt-wl-status]');
    var note = root.querySelector('[data-mt-wl-note]');
    var form = document.getElementById(root.getAttribute('data-form-id')) || (root.closest('.product__form, .product-form, product-form, .product') || document).querySelector('form[action*="/cart/add"]');
    var labels = { add: root.getAttribute('data-label-add') || L.add || 'Save to Wishlist', saved: root.getAttribute('data-label-saved') || L.saved || 'Saved' };
    var meta = { title: root.getAttribute('data-product-title'), handle: root.getAttribute('data-product-handle') };
    var busy = false;
    var lastVariant = null;

    function currentVariant() {
      var v = null;
      if (form) {
        var sel = form.id ? document.querySelector('select[name="id"][form="' + form.id + '"]') : null;
        var inp = form.querySelector('[name="id"]');
        v = (sel && sel.value) || (inp && (inp.value || inp.getAttribute('value'))) || null;
      }
      if (!v) {
        var q = new URLSearchParams(location.search).get('variant');
        v = q || root.getAttribute('data-variant-id') || null;
      }
      return v ? String(v) : null;
    }
    // quiet = announce to assistive tech but keep it off-screen (the label already says it)
    function setStatus(text, quiet) { if (!status) return; status.textContent = text || ''; status.classList.toggle('is-quiet', !!quiet); }
    function render() {
      var id = currentVariant();
      var saved = !!id && store.has(id);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      btn.setAttribute('title', saved ? (L.removeHint || 'Remove from wishlist') : '');
      if (label) label.textContent = saved ? labels.saved : labels.add;
      if (view) { view.hidden = !saved; view.setAttribute('href', pageUrl()); }
      if (sep) sep.hidden = !saved;
    }
    function pop() {
      btn.classList.remove('is-pop');
      void btn.offsetWidth; // restart the animation
      btn.classList.add('is-pop');
      setTimeout(function () { btn.classList.remove('is-pop'); }, 600);
    }
    function toggle() {
      var id = currentVariant();
      if (!id) { setStatus(L.pickVariant || 'Pick an option first.'); return; }
      if (busy) return;
      var wasSaved = store.has(id);
      busy = true; btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true');
      if (label && !wasSaved) label.textContent = (L.saving || 'Saving') + '…';
      setStatus('');
      (wasSaved ? apiRemove(id) : apiAdd(id)).then(function () {
        if (wasSaved) store.remove(id); else store.add(id, meta);
        render();
        if (!wasSaved) pop();
        setStatus(wasSaved ? (L.removedStatus || 'Removed.') : (L.savedStatus || 'Saved.'), !wasSaved);
        if (!wasSaved) store.ready(true); // pick up image and price for the panel
      }).catch(function () {
        render();
        setStatus(L.error || 'That did not save. Try again.');
      }).finally(function () {
        busy = false; btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy');
      });
    }
    function guestClick() {
      if (!note) { startSignIn(); return; }
      var open = !note.hidden;
      note.hidden = open;
      if (!open) {
        var primary = note.querySelector('[data-mt-wl-signin]');
        if (primary) primary.focus({ preventScroll: false });
      }
    }
    function startSignIn() {
      var id = currentVariant();
      if (!id) { setStatus(L.pickVariant || 'Pick an option first.'); return; }
      setPending({ variant: id, handle: meta.handle, title: meta.title, at: Date.now() });
      // Shopify only honours a plain path (+ ?variant=) as return_to; anything else lands on the
      // account dashboard. The pending record above carries everything else we need.
      location.assign(loginUrlFor(location.pathname + '?variant=' + encodeURIComponent(id)));
    }

    btn.addEventListener('click', function () { CUSTOMER ? toggle() : guestClick(); });
    if (note) {
      var signin = note.querySelector('[data-mt-wl-signin]');
      var dismiss = note.querySelector('[data-mt-wl-dismiss]');
      if (signin) signin.addEventListener('click', startSignIn);
      if (dismiss) dismiss.addEventListener('click', function () { note.hidden = true; btn.focus(); });
    }
    // variant changes: pickers fire change; the theme also rewrites the hidden input, so poll lightly
    document.addEventListener('change', function () { setTimeout(render, 0); });
    setInterval(function () { var v = currentVariant(); if (v !== lastVariant) { lastVariant = v; render(); } }, 700);
    document.addEventListener('mt:wishlist:change', render);

    render();
    store.ready().then(render);
    return { root: root, render: render, setStatus: setStatus, pop: pop, currentVariant: currentVariant };
  }

  /* ---------- header heart ---------- */
  function initHeader() {
    var links = document.querySelectorAll('[data-mt-wl-header]');
    if (!links.length) return;
    function update() {
      var n = store.ids().length;
      links.forEach(function (a) {
        var c = a.querySelector('[data-mt-wl-count]');
        if (c) { c.textContent = n; c.hidden = n === 0; }
        a.classList.toggle('has-items', n > 0);
        a.setAttribute('href', pageUrl());
      });
    }
    document.addEventListener('mt:wishlist:change', update);
    if (CUSTOMER) store.ready().then(update);
  }

  /* ---------- finish a save that started before sign-in ---------- */
  function resumePending(controls) {
    var p = getPending();
    if (!p) return;
    if (!CUSTOMER) return; // still signed out (e.g. abandoned sign-in); keep it until it expires
    var control = controls.filter(function (c) { return c.root.getAttribute('data-product-handle') === p.handle; })[0];
    apiAdd(p.variant).then(function () {
      setPending(null);
      store.add(p.variant, p);
      store.ready(true);
      if (control && control.currentVariant() === String(p.variant)) {
        control.render();
        control.pop();
        control.setStatus(L.savedStatus || 'Saved to your wishlist.', true);
      } else {
        if (control) control.render();
        toast(esc(L.savedStatus || 'Saved to your wishlist.') + ' <a href="' + esc(pageUrl()) + '" data-mt-wl-open>' + esc(L.view || 'View wishlist') + '</a>');
      }
    }).catch(function () {
      setPending(null);
      if (control) control.setStatus(L.error || 'That did not save. Try again.');
    });
  }

  /* ---------- Gift Reggie wishlist page ---------- */
  function initWishlistPage() {
    var page = document.querySelector('.giftreggie-front.giftreggie-wishlist, .giftreggie-front.giftreggie-wishlist-entry');
    if (!page) return;
    var isEntry = page.classList.contains('giftreggie-wishlist-entry') || /not logged in/i.test(page.textContent);
    var heading = page.querySelector('h2, h3');

    // signed-out: the app prints one sentence; give it a real card (original stays for no-JS)
    if (isEntry && !CUSTOMER) {
      var p = page.querySelector('form > p, p');
      if (p && /not logged in/i.test(p.textContent)) {
        var card = document.createElement('div');
        card.className = 'mt-wl-card';
        card.innerHTML = HEART + '<h3>' + esc(L.signedOutTitle || 'Your wishlist') + '</h3><p>' + esc(L.signedOutText || '') + '</p>' +
          '<a class="mt-wl-card-btn" href="' + loginUrlFor(cfg.wishlistUrl) + '">' + esc(L.signIn || 'Sign in') + '</a>';
        p.classList.add('mt-wl-hidden');
        p.parentNode.insertBefore(card, p);
      }
      return;
    }

    var isOwner = page.classList.contains('giftreggie-manager');
    var list = page.querySelector('ul.giftreggie-mobile');
    function cards() { return page.querySelectorAll('ul.giftreggie-mobile li.registry-variant'); }
    function rowIds() { var ids = []; page.querySelectorAll('#view-registry tr.registry-variant').forEach(function (tr) { ids.push(tr.getAttribute('data-id')); }); return ids; }
    if (isOwner && CUSTOMER) store.setIds(rowIds()); // the page is the source of truth after a remove/add

    // Add to Cart on the cards: the app ships a plain POST form that reloads onto /cart.
    // Add through the cart API instead so Rebuy's Smart Cart opens like it does everywhere else.
    page.querySelectorAll('ul.giftreggie-mobile li.registry-variant form[action*="/cart/add"]').forEach(function (form) {
      var btn = form.querySelector('button[name="id"]');
      if (!btn) return;
      var idle = btn.textContent;
      var note = document.createElement('p');
      note.className = 'mt-wl-card-status';
      form.appendChild(note);
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return; // let the form post
        e.preventDefault();
        if (btn.classList.contains('is-busy')) return;
        btn.classList.add('is-busy');
        btn.textContent = (L.adding || 'Adding') + '…';
        note.textContent = '';
        cartAdd(btn.value).then(function () {
          btn.textContent = L.added || 'Added';
          btn.classList.add('is-added');
          emit('mt:cart:added', { id: btn.value });
          nudgeSmartCart();
          setTimeout(function () { btn.textContent = idle; btn.classList.remove('is-added'); }, 2000);
        }).catch(function (err) {
          btn.textContent = idle;
          note.textContent = (err && (err.description || err.message)) || 'That did not add. Try again.';
        }).finally(function () { btn.classList.remove('is-busy'); });
      });
    });

    // Remove on the cards: the app's form reloads the page. Do it in place instead.
    function cardFor(variantId) {
      var found = null;
      cards().forEach(function (c) { var v = c.querySelector('input[name="id"]'); var b = c.querySelector('button[name="id"]'); if ((v && v.value === String(variantId)) || (b && b.value === String(variantId))) found = c; });
      return found;
    }
    function dropCard(variantId) {
      var li = cardFor(variantId);
      var tr = page.querySelector('#view-registry tr.registry-variant[data-id="' + variantId + '"]');
      if (tr) tr.remove();
      if (!li) return;
      li.classList.add('is-removing');
      setTimeout(function () { li.remove(); if (!cards().length) showEmpty(); }, 260);
    }
    page.querySelectorAll('ul.giftreggie-mobile li.registry-variant .giftreggie-registry-variant-delete form').forEach(function (form) {
      var input = form.querySelector('input[name="id"]');
      var btn = form.querySelector('button.remove-button');
      if (!input || !btn) return;
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        if (btn.disabled) return;
        btn.disabled = true;
        var id = input.value;
        apiRemove(id).then(function () { store.remove(id); dropCard(id); }).catch(function () { btn.disabled = false; });
      });
    });

    // Delete Wishlist: the app's own handler calls confirm() with a broken message that reads
    // "[object Object]". Ask properly first; if the shopper agrees, auto-accept the app's prompt.
    var del = page.querySelector('#delete-button');
    if (del) {
      del.addEventListener('click', function (e) {
        if (!window.confirm(L.deleteConfirm || 'Delete your whole wishlist? This cannot be undone.')) {
          e.preventDefault(); e.stopImmediatePropagation(); return;
        }
        var orig = window.confirm;
        window.confirm = function () { window.confirm = orig; return true; };
        setTimeout(function () { if (window.confirm !== orig) window.confirm = orig; }, 1000);
      }, true);
    }

    // one line under the name
    if (heading && !page.querySelector('.mt-wl-sub')) {
      var sub = document.createElement('p');
      sub.className = 'mt-wl-sub';
      sub.textContent = isOwner ? (L.ownerSub || '') : (L.guestSub || '');
      if (sub.textContent) heading.insertAdjacentElement('afterend', sub);
    }

    // copy-link control beside the permalink
    var link = page.querySelector('.giftreggie-permalink');
    if (link && !page.querySelector('.mt-wl-copy')) {
      var wrap = document.createElement('div');
      wrap.className = 'mt-wl-copy';
      link.parentNode.insertBefore(wrap, link);
      wrap.appendChild(link);
      var copy = document.createElement('button');
      copy.type = 'button';
      copy.className = 'mt-wl-copy-btn';
      copy.textContent = L.copy || 'Copy link';
      wrap.appendChild(copy);
      copy.addEventListener('click', function () {
        var done = function () {
          copy.textContent = L.copied || 'Copied';
          copy.classList.add('is-copied');
          setTimeout(function () { copy.textContent = L.copy || 'Copy link'; copy.classList.remove('is-copied'); }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link.value).then(done, function () { link.select(); done(); });
        else { link.select(); try { document.execCommand('copy'); } catch (e) { /* ignore */ } done(); }
      });
    }

    // the app's "begin browsing" link points at wedding gifts; retarget it
    var browse = page.querySelector('.giftreggie-add-products a');
    if (browse) {
      browse.setAttribute('href', cfg.browseUrl || '/collections/new');
      browse.textContent = cards().length ? (L.keepBrowsing || 'Keep browsing') : (cfg.browseLabel || 'Browse');
    }

    // empty list: a proper empty state instead of an empty grid
    function showEmpty() {
      if (page.querySelector('.mt-wl-card--empty')) return;
      var empty = document.createElement('div');
      empty.className = 'mt-wl-card mt-wl-card--empty';
      empty.innerHTML = HEART + '<h3>' + esc(L.emptyTitle || 'Nothing saved yet.') + '</h3><p>' + esc(L.emptyText || '') + '</p>' +
        '<a class="mt-wl-card-btn" href="' + esc(cfg.browseUrl || '/collections/new') + '">' + esc(cfg.browseLabel || 'Browse') + '</a>';
      var anchor = page.querySelector('.giftreggie-add-products') || list;
      if (anchor) anchor.parentNode.insertBefore(empty, anchor); else page.appendChild(empty);
      var addP = page.querySelector('.giftreggie-add-products');
      if (addP) addP.classList.add('mt-wl-hidden');
      // the app prints its own "This wishlist is empty!" line as well
      page.querySelectorAll('p, div, span').forEach(function (el) {
        if (el.children.length === 0 && /wishlist is empty/i.test(el.textContent)) el.classList.add('mt-wl-hidden');
      });
    }
    if (!cards().length && isOwner) showEmpty();

    // already bought: needs the list's created date, so wait for the API, then drop the cards
    if (isOwner && CUSTOMER) {
      store.ready(true).then(function () { return bought.run(); }).then(function (removed) {
        if (!removed.length) return;
        removed.forEach(function (p) { dropCard(p.variant_id); });
        var n = boughtNotice(removed, function () { location.reload(); });
        var anchor = page.querySelector('.giftreggie-sharing') || heading;
        if (anchor) anchor.insertAdjacentElement('afterend', n); else page.insertBefore(n, page.firstChild);
      });
    }
  }

  /* ---------- boot ---------- */
  function boot() {
    var controls = [];
    document.querySelectorAll('[data-mt-wl]').forEach(function (root) {
      if (root.__mtwl) return;
      root.__mtwl = true;
      controls.push(initControl(root));
    });
    initHeader();
    initWishlistPage();
    drawer.bindTriggers();
    resumePending(controls);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
